"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'doorfee',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1
      }
    };
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/search/door_fee_record';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};